import { PATH } from '@/app/constants/path';
import { appClientConfig } from '@/app/utils/appClientConfig';
import { FieldError } from '@/components/FieldError';
import Link from 'next/link';
import { Control, Controller } from 'react-hook-form';

import { Checkbox } from '@material-ui/core';

import styles from './TermsAndConditions.module.scss';

const termsAndConditionsPath = PATH.TERMS_AND_CONDITIONS;
const privacyPolicyUrl = appClientConfig.privacyPolicyUrl;

interface TermsAndConditionsProps {
  control: Control;
  error?: boolean;
  errorMessage?: string;
}

const TermsAndConditions = ({ control, error, errorMessage }: TermsAndConditionsProps) => (
  <div className={styles.container}>
    <Controller
      name="agreeTerms"
      control={control}
      defaultValue={false}
      render={({ onChange, value }) => (
        <Checkbox
          checked={value}
          onChange={() => onChange(!value)}
          style={{ color: value ? '#0f68ef' : '#889096', padding: 6, paddingLeft: 0 }}
        />
      )}
    />

    <span className={styles.terms}>
      I agree to the{' '}
      <Link
        prefetch={false}
        href={termsAndConditionsPath}
        as={termsAndConditionsPath}
        className={styles.link}
      >
        terms and conditions
      </Link>{' '}
      and{' '}
      <Link prefetch={false} href={privacyPolicyUrl} as={privacyPolicyUrl} className={styles.link}>
        privacy policy
      </Link>
      .
    </span>

    {error && <FieldError errorMessage={errorMessage} />}
  </div>
);

export default TermsAndConditions;
